import { useDispatch } from "react-redux";
import { getUrlForDownload, getUrlForDownloadLD } from "../../../api/document";
import { IDocument } from "../../../models/document";
import { showBackendMessage } from "../../../helpers/messagesHelper";
import { useIntl } from "react-intl";
import Messages from "../../../localization/Messages";
import { useCallback } from "react";
import { Roles } from "../../../../src/models/userData";
import { useAuth } from "../../../../src/hooks/useAuth";

export function useDownloadDocument() {
    const dispatch = useDispatch();
    const intl = useIntl();
    const { hasRole } = useAuth();
    const isDispatcher = hasRole(Roles.PASSENGER_CABIN_CRUISES_DISPATCHER);
    const isOnCallUser = hasRole(Roles.ON_CALL_DISPATCHER);
    const isLDUser = hasRole(Roles.LOCKS_AND_DOCKS_DISPATCHER);

    const apiFn =
        isDispatcher || isOnCallUser ? getUrlForDownload : isLDUser ? getUrlForDownloadLD : null;

    const download = useCallback(
        async (document: IDocument) => {
            if (!apiFn) return;
            try {
                const res = await apiFn(document.name, document.path, true);
                window.open(res.data, "_blank");
            } catch {
                dispatch(showBackendMessage(intl, "error", "downloading", Messages.document));
            }
        },
        [apiFn, dispatch, intl],
    );

    return download;
}
